/// <field name='lc' type='Object'>Labour charges object</field>
window.travel = cafm.hd.travel = {
    listSelector: '#travelLv',
    changedHandlerName: 'cafm.hd.travel.onTravelChanged',
    list: null,
    init: function () {
        /// <summary>Labour charges initialiser</summary>

        $('.travelMessage').show();
    },
    dataRetrieved: function (d) {
        /// <summary>Handler for when travel list data has been retrieved</summary>
        /// <param name="d" type="Array">Array of labour charge data</param>

        travel.list = $(travel.listSelector);
    },
    /// <field name='listToolbar' type='Object'>Labour charges list toolbar</field>
    toolbar: {

        addtravel: function (e) {

            var at = travel.getActiveTravel();
            var active = at != null;
            var action = active ? 'Helpdesk/EndTravel' : 'Helpdesk/StartTravel';
            cafm.views.openChildActionWindow({
                action: action,
                title: $(e.currentTarget).text(),
                onLoad: function (pnl) {
                    
                    cafm.views.bindActionWindowViewModel({

                        WorkOrderId: cafm.hd.workOrder.ID,
                        TradePersonID: cafm.auth.personId(),
                        TravelDateTime: cafm.web.funcs.getNowUTC(),
                        isActive: active
                    })
                }
            });
        },
        recordtravel: function (e) {
            /// <summary>Start travel handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            var viewModel = cafm.views.getActionWindowViewModel();
            var oat = viewModel.isActive ? cafm.enums.OfflineActionType.EndTravel : cafm.enums.OfflineActionType.StartTravel;                        
            
            cafm.actions.execute({
                url: cafm.url.api('~/WorkOrder/RecordTravel'),
                values: viewModel,
                elementId: cafm.res.consts.ElementId_ActionForm,
                loaderSelector: '.winButtons .btn[data-key="RecordTravel"]',
                offlineActionType: oat,
                statusCodeFuncs: {
                    200: function (r) {
                        
                        cafm.handlers.exe(travel.changedHandlerName, r);
                        travel.refreshList();
                        cafm.views.closeActionWindow();
                        cafm.hd.workOrder.set('IsTravelling', cafm.hd.travel.getActiveTravel(null, true) != null);
                    }
                },
                // handle offline
                fallback: function (r) {

                    var tl = cafm.hd.getWorkOrderChildList('Travel');

                    if (isNullOrUndefined(tl)) {

                        tl = [];
                    }
                    else if (isFunc(tl.toJSON)) {

                        tl = tl.toJSON();
                    }

                    if (!viewModel.isActive) {

                        tl.unshift({

                            TradePersonId: cafm.auth.personId(),
                            TradePersonName: cafm.auth.personName(),
                            StartDateTime: cafm.util.toIsoDateString(viewModel.TravelDateTime),
                            Completed: false,
                            Hours: null,
                            Minutes: null
                        });

                        cafm.hd.workOrder.set('Travel', tl);
                        cafm.hd.workOrder.set('TravelCount', tl.length);
                    }
                    else {
                        
                        var at = cafm.util.find(tl, function (t) { return (t.TradePersonId === cafm.auth.personId()) && !t.Completed; });
                        var ts = cafm.util.ensureDate(at.StartDateTime);
                        var te = cafm.util.ensureDate(viewModel.TravelDateTime);

                        var hoursMins = cafm.util.datesHoursMinsDiff(ts, te);
                        at.Hours = hoursMins.hours;
                        at.Minutes = hoursMins.minutes;
                        at.Completed = true;

                        cafm.hd.workOrder.set('Travel', tl);
                    }

                    cafm.hd.workOrder.set('IsTravelling', cafm.hd.travel.getActiveTravel(cafm.hd.workOrder, true) != null);

                    // this sets the updated work order in the cache
                    cafm.hd.workOrderCachingHandler.cacheWorkOrderInContext();

                    cafm.views.showOfflineMessage(true);
                    cafm.handlers.exe(travel.changedHandlerName, r);
                    travel.refreshList();
                    cafm.views.closeActionWindow();

                }
            });
        },
        cancel: function (e) {
            /// <summary>Cancel handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            cafm.views.closeActionWindow();
        }
    },
    refreshList: function (cb) {

        cafm.util.refreshList({
            listSelector: travel.listSelector,
            key: cafm.res.consts.DataKey_HelpdeskTravel,
            callback: cb
        });
    },
    enablePermissibleFeatures: function (p) {

        var lh = $('#travelLv .cLvHead');

        if (p.edit) {

            lh.show();
        }
        if (p.edit) {

            $('[data-key="AddTravel"]', lh).show();
        }
    },
    enablePermissibleFeaturesOffline: function (p) {

        var lh = $('#travelLv .cLvHead');
        var canEdit = hdActions.offlineSecurity.isAllowed(cafm.enums.LogWorkOrderAction.RecordTravel);

        if (isMobile && canEdit) {

            lh.show();
        }
        if (canEdit) {

            $('[data-key="AddTravel"]', lh).show();
        }
    },
    getWorkOrderTravel: function () {

        return cafm.hd.getWorkOrderChildList('Travel');
    },
    getActiveTravel: function (workOrder, anyEngineer) {

        var tl = workOrder ? workOrder.Travel : cafm.hd.getWorkOrderChildList('Travel');
        var active;

        if (cafm.util.hasItem(tl)) {

            if (tl.toJSON) tl = tl.toJSON();
            var pid = cafm.auth.personId();
            active = cafm.util.find(tl, function (t) {

                return (anyEngineer || t.TradePersonId === pid) && !t.Completed;
            });
        }
        else {

            active = null;
        }

        return active;
    }
}